import { useEffect, useState } from "react";
import {
  RequisiteIProps,
  useAvtovazRequisites,
} from "~/entity/AvtovazRequisites";

export const useGetRequisites = () => {
  const [data, setData] = useState<RequisiteIProps[]>(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { getAvtovazRequisiteList } = useAvtovazRequisites();

  const fetchData = async () => {
    try {
      setIsLoading(false);
      setError(null);

      const res = await getAvtovazRequisiteList();
      if (res.status >= 400) {
        throw new Error(`${res.status}`);
      }
      setData(res.data);
    } catch (error) {
      setError("Ошибка запроса реквизитов");
    } finally {
      setIsLoading(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const refetch = () => {
    fetchData();
  };
  return { data, error, isLoading, refetch };
};
